import React from "react";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { urlFor, client } from "../../client";

import "./portfolio.scss";

const Portfolio = () => {
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  useEffect(() => {
    const query = '*[_type == "works"]';

    client.fetch(query).then((data) => {
      setWorks(data);
      setFilterWork(data);
    });
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };
  return (
    <div
      id="portfolio"
      className="container-homeP h-screen w-screen overflow-hidden"
    >
      <div className="con-left container-left">
        <div className="informationP">
          <motion.div
            className="font-face-nh"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.5 }}
            transition={{ delay: 0.5, duration: 3.0 }}
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            <h1 className="first-nameP ml-[4vw] md:ml-[4vw]">Portfolio</h1>
          </motion.div>
          <div>
            <h1 className="font-body text-white text-xl mt-4 md:text-2xl ml-[4vw]">
              Few projects I have worked on.
            </h1>
          </div>
        </div>
      </div>

      <div className="container-right overflow-auto">
        <>
          <div className="app__work-filter">
            {["Front-end", "Full-stack", "Framework", "MERN", "API", "All"].map(
              (item, index) => (
                <div
                  key={index}
                  onClick={() => handleWorkFilter(item)}
                  className={`app__work-filter-item app__flex p-text ${
                    activeFilter === item ? "item-active" : ""
                  }`}
                >
                  {item}
                </div>
              )
            )}
          </div>
          <motion.div
            animate={animateCard}
            transition={{ duration: 0.5, delayChildren: 0.0 }}
            className="app__work-portfolio"
          >
            {filterWork.map((work, index) => (
              <div className="p" key={index}>
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <div className="p-img">
                    <img src={urlFor(work.imgUrl)} alt={work.name} />
                  </div>
                </a>
              </div>
            ))}
          </motion.div>
        </>
      </div>
    </div>
  );
};

export default Portfolio;
